import { getDefaultSteps } from "../../utils/steps";

/**
 * actions types
 * @type {String}
 */
export const REQUEST_STEPS = 'REQUEST_STEPS';
export const RECEIVE_STEPS = 'RECEIVE_STEPS';

/**
 * initial state
 * @type {Object}
 */
const initialState = {
  data: null,
  loading: false,
};

/**
 * reducer
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_STEPS:
      return {
        ...state,
        loading: true,
      };

    case RECEIVE_STEPS:
      return {
        ...state,
        data: action.data,
        loading: false,
      };

    default:
      return state;
  }
}

/**
 * request steps
 * @return {Object}
 */
export function requestSteps() {
  return { type: REQUEST_STEPS };
}

/**
 * receive steps
 * @param  {Object} data
 * @return {Object}
 */
export function receiveSteps(data) {
  return { type: RECEIVE_STEPS, data };
}

export function prepareSteps(products=[], items=[], options=[]) {
  return dispatch => {
    dispatch(requestSteps());

    const p = products.map(item => ({
      value: item.id,
      label: item.name.toLowerCase(),
      trigger: 'modules-step-one'
    }));

    const m = items.map(item => ({
      value: item.id,
      label: item.name.toLowerCase(),
      trigger: 'options-step-one'
    }));

    const o = options.map(item => ({
      value: item.id,
      label: item.name.toLowerCase(),
      trigger: 'farewell'
    }));

    const steps = [
      ...getDefaultSteps(),
      { id: 'products-step-two', options: p },
      { id: 'modules-step-two', options: m },
      { id: 'options-step-two', options: o },
    ]

    dispatch(receiveSteps(steps));
  }
}
